var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-page',{attrs:{"page-no":_vm.pageId}})
}
var staticRenderFns = []

export { render, staticRenderFns }